import { TablePagination } from "@mui/material";

const DraftPostGridPagination = ({ draftList,
    rowsPerPage,
    page,
    handleChangePage,
    handleChangeRowsPerPage
}) => {

    return (
        <>
            <TablePagination
                component="div"
                rowsPerPageOptions={[10, 20, 30, 50]}
                count={draftList.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </>
    )
}

export default DraftPostGridPagination;